"use client";

export function MapLocations({ places, zoomToSelectedLoc }) {
  return (
    <div className="grid w-full grid-cols-1 gap-2">
      {places.map((place, index) => (
        <div
          key={index}
          onClick={(e) => zoomToSelectedLoc(e, place, place, index)}
          className="relative flex flex-col items-center justify-center w-full h-24 p-4 overflow-hidden transition-all duration-300 border shadow-xl cursor-pointer lg:hover:border-button lg:hover:bg-button lg:hover:text-button-foreground bg-card rounded-card-radius text-card-foreground"
        >
          {/* <img
            src="./assets/wine.jpg"
            alt={place?.title}
            className="absolute object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-black opacity-50"></div> */}
          {/* drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] */}
          <h4 className="level-2">{place?.title}</h4>
        </div>
      ))}
    </div>
  );
}
